export const MAX_EXCEL_PREVIEW_BYTES = 4 * 1024 * 1024;

export const isWordFile = (file = {}) => {
  const type = String(file.FileType || file.fileType || file.MimeType || file.mimeType || '').trim().toLowerCase();
  const name = String(file.FileName || file.fileName || file.FileNameWithExtension || '').trim().toLowerCase();
  const extension = String(file.FileExtension || file.fileExtension || '').trim().replace(/^\./, '').toLowerCase();

  return extension === 'doc'
    || extension === 'docx'
    || /\.docx?$/.test(name)
    || type === 'application/msword'
    || type === 'application/doc'
    || type === 'application/docx'
    || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
};

const isExcelFile = (file = {}) => {
  const type = String(file.FileType || file.mimeType || '').toLowerCase();
  const name = String(file.FileName || file.fileName || '').toLowerCase();
  const extension = String(file.FileExtension || file.fileExtension || '').replace(/^\./, '').toLowerCase();
  return type.includes('excel') || type.includes('spreadsheet') || /\.(xls|xlsx)$/.test(name) || extension === 'xls' || extension === 'xlsx';
};

export const getExcelPreviewDisabledReason = (file = {}) => {
  const size = Number(file.FileSizeBytes || file.fileSizeBytes || file.FileSize || 0);
  return isExcelFile(file) && size >= MAX_EXCEL_PREVIEW_BYTES
    ? 'This Excel workbook is too large to preview. Download it to open in Excel.'
    : '';
};
